import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  DEFAULT_ERROR_IMAGE:string = "assets/images/error.png";

  constructor(private http:HttpClient) { }

  getMediaItemUrl(item:any, errorReturn:any=this.DEFAULT_ERROR_IMAGE) {
    if(item?.url) {
      return `${environment.baseUrl}${item.url}`;
    }
    return errorReturn;
  }

  getMediaItemUrls(item:any) {
    let result:any = [];
    if(item.data) {
      for(let k of item.data) {
        result.push(`${environment.baseUrl}${k.url}`);
      }
    }
    return result;
  }
}
